import { Box, Button, Flex, MediaBox, Typography } from "@jewlr/storybook/core"
import loadable from "@loadable/component"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import { withRouter } from "react-router-dom"
import styled from "styled-components"

import IntersectionWrapper from "components/common/intersection-wrapper"
import { IS_CA, IS_US, IS_UK, IS_AU, retry } from "helpers/application"

const FooterBottom = loadable(() => retry(() => import("./footer-bottom")))
const FooterContent = loadable(() => retry(() => import("./footer-content")))

const SubscribeWrapper = styled(Flex).attrs({
  contain: true,
  display: "block",
})`
  align-items: center;
  margin: 0 auto;
  ${(props) => props.theme.mediaQueries.desktop`
    width: 35%
  `}
`

const InternalFooterMain = ({ location }) => {
  const is_ca = IS_CA()
  const is_us = IS_US()
  const is_uk = IS_UK()
  const is_au = IS_AU()

  const TriggerDigioh = () => {
    console.log("Digioh trigger")
    if (window.innerWidth >= 760) {
      //call the desktop Digioh
      if (is_us) {
        console.log("Digioh desktop us: 271057")
        window.DIGIOH_API.LIGHTBOX.loadLightbox(
          "c1010363-e859-4bdc-90b1-6cc8ce7e13fb"
        )
      } else if (is_ca) {
        console.log("Digioh desktop is_ca: 271081")
        window.DIGIOH_API.LIGHTBOX.loadLightbox(
          "64f416a9-ff8a-4cad-9ee1-1d8ef6b9cdde"
        )
      } else if (is_uk || is_au) {
        console.log("Digiog desktop UK&AU : 262154")
        window.DIGIOH_API.LIGHTBOX.loadLightbox(
          "5961dbd1-4cfb-416b-befe-492ef795bc43"
        )
      }
    } else {
      //call the mobile Digioh
      if (is_us) {
        console.log("Digioh mobile us: 276303")
        window.DIGIOH_API.LIGHTBOX.loadLightbox(
          "243741b7-1c89-4948-b0bf-5b14ea27a1af"
        )
      } else if (is_ca) {
        console.log("Digioh mobile ca: 276308")
        window.DIGIOH_API.LIGHTBOX.loadLightbox(
          "bd425272-7efd-4a63-94c3-1927613a931d"
        )
      } else if (is_uk) {
        console.log("Digiog mobile UK : 276449")
        window.DIGIOH_API.LIGHTBOX.loadLightbox(
          "9474cd3e-6673-4493-ac2c-9fafc3fadda6"
        )
      } else if (is_au) {
        console.log("Digiog mobile AU :  276451")
        window.DIGIOH_API.LIGHTBOX.loadLightbox(
          "ce1f675f-479d-47c2-a61d-daaf3b311a4a"
        )
      }
    }
  }

  if (
    location.pathname.includes("/checkout") ||
    location.pathname.includes("/payments")
  ) {
    return ""
  }
  return (
    <IntersectionWrapper id="footer-wrapper">
      <Box
        bg="grey.20"
        mt={{ tablet: 4 }}
        px={2}
        py={{ _: 4, tablet: 5 }}
        textAlign="center"
      >
        <SubscribeWrapper>
          <Typography
            color="black"
            fontSize={{ _: "16px", tablet: "18px" }}
            mb={{ _: 1, desktop: 2 }}
          >
            <Box as="span">Subscribe to our emails and save 10%</Box>
          </Typography>
          <Box>
            {["", "_desktop"].map((format) => (
              <MediaBox
                key={format}
                {...(format === "_desktop"
                  ? { greaterThanOrEqual: "tablet" }
                  : { lessThan: "tablet" })}
              >
                <Button
                  as="button"
                  bg="white"
                  color="black"
                  id={`subscribe_newsletter${format}`}
                  mx="auto"
                  onClick={() => TriggerDigioh()}
                  width={{ _: "70%", desktop: "100%" }}
                >
                  Get Your Code!
                </Button>
              </MediaBox>
            ))}
          </Box>
        </SubscribeWrapper>
      </Box>
      <Box as="footer" bg="neutral" pb={3} pt={6}>
        <FooterContent />
        <FooterBottom />
      </Box>
    </IntersectionWrapper>
  )
}
const mapStateToProps = () => {
  return {}
}

const mapDispatchToProps = () => ({})

InternalFooterMain.propTypes = {
  location: PropTypes.object,
}

const FooterMain = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalFooterMain)

export default withRouter(FooterMain)
